import React from "react";
import {Dictionary} from "../../components/Dictionary";
import {User} from "../../components/User";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class SubScriptionInfoElement extends React.Component<any, any> {
    private dictionary: Dictionary = new Dictionary();
    private user: User = new User();


    render() {
        if (!this.user.hasRight('subscription/info')) {
            return (<></>);
        }

        const dictionary = this.dictionary, getClassName: any = (timeInput: string) => {
            const seconds: number = ((new Date()).getTime() - (new Date(timeInput + 'Z')).getTime()) / 1000;
            if (seconds < -5) {
                return 'text-danger';
            }
            if (seconds < 60) {
                return 'text-success';
            }
            if (seconds < 600) {
                return 'text-warning';
            }
            return 'text-danger';
        };

        const props = this.props;

        return (
            <div className="row">
                <div className="table-responsive">
                    <table className="table table-hover table-sm align-middle">
                        <thead>
                        <tr>
                            <th className="sortable" data-sortkey="s.subscription_id">
                                {this.dictionary.get['subscriber']}
                                <i className="bi bi bi-sort-down-alt"></i>
                            </th>
                            <th className="sortable" data-sortkey="s.status">
                                {this.dictionary.get['status']}
                            </th>
                            {props.total &&
                                <th className="sortable" data-sortkey="s.last_count" style={{textAlign: 'right'}}>
                                    {this.dictionary.get['last_count']}
                                </th>}
                            {props.total &&<th className="sortable" data-sortkey="s.started_at">
                                {this.dictionary.get['started_at']}
                            </th>}
                            <th className="sortable" data-sortkey="s.updated_at">
                                {this.dictionary.get['updated_at']}
                            </th>
                            {props.total && <th className="sortable" data-sortkey="s.last_active">
                                {this.dictionary.get['last_active']}
                            </th>}
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.items.map(function (elem: any) {
                            return (
                                <tr key={elem.subscription_id} data-id={elem.subscription_id}>
                                    <td className={getClassName(elem.updated_at)}>
                                        <strong>{dictionary.get[elem.subscription_id]}</strong>
                                    </td>
                                    <td>{Util.status(elem.status, {
                                        style: {
                                            fontWeight: 'normal',
                                            fontSize: '11px'
                                        }
                                    })}</td>
                                    {props.total && <FormattedNumber value={elem.last_count}
                                                                     parentNode="td" suffix={dictionary.get['pc']}
                                                                     style={{textAlign: 'right'}}/>}
                                    {props.total && <td>{Util.timeAgo(elem.started_at, 'text-default')}</td>}
                                    <td><strong>{Util.timeAgo(elem.updated_at)}</strong></td>
                                    {props.total && <td>{Util.timeAgo(elem.last_active, 'text-default')}</td>}
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
